const STRINGS={
    NotConnected:{
        en:'Not Connected ',
        'pt-BR':'Não Conectado ',
        fi:'Ei yhdistetty '
    },
    Login:{
        en:'Login',
        'pt-BR':'Entrar',
        fi:'Kirjaudu sisään'
    },
    SessionExpired:{
        en:' (Session Expired!)',
        'pt-BR':' (Sessão Expirada!)',
        fi:' (Istunto vanhentunut!)'
    },
    InvalidPageOrAccessNotAllowed:{
        en:'Invalid Page or Access not Allowed',
        'pt-BR':'Página Inválida ou Acesso não Permitido',
        fi:'Virheellinen sivu tai käyttöoikeus ei ole sallittu'
    },
    UserNotAuthenticated:{
        en:'User not Authenticated - Please Login',
        'pt-BR':'Usuário não Autenticado - Por Favor efetue o Login',
        fi:'Käyttäjää ei ole todennettu - Kirjaudu sisään'
    }
}

export const getStringLang=(stringKey,langKey)=>{
  const STRING=STRINGS[stringKey];
  if(!STRING) return 'MISSING_STRING_'+stringKey;
  return STRING[langKey]||'MISSING_LANG_'+langKey+'_STRING_'+stringKey;
};